import { usesRedesignedPipelineForm } from './projectConfig';

/** True when the active DPR shift is marked skipped in Redux/header checkboxes. */
export function isDprShiftSkipped(skipDay, skipNight, shift) {
  if (shift === 'day') return Boolean(skipDay);
  if (shift === 'night') return Boolean(skipNight);
  return false;
}

export function getDprShiftLabel(shift) {
  return shift === 'night' ? 'Night' : 'Day';
}

/** Parse API skip flag (0/1, boolean, or string) — null when absent. */
export function parseDprSkipFlag(value) {
  if (value === undefined || value === null || value === '') return null;
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  return Boolean(value);
}

/**
 * Night-shift skip for header checkboxes.
 * Offshore welding: active (not skipped) when API omits the flag.
 * When API sends 0/1 explicitly, respect backend.
 */
export function resolveDprSkipNightFromLog(dprLogData, project) {
  const parsed = dprLogData ? parseDprSkipFlag(dprLogData.isSkippedNightShift) : null;
  if (parsed !== null) return parsed;
  if (usesRedesignedPipelineForm(project)) return false;
  return false;
}

/** Default night-shift skip when no DPR log exists yet for the selected date. */
export function defaultDprSkipNightForProject(project) {
  if (usesRedesignedPipelineForm(project)) return false;
  return false;
}
